module.exports = __webpack_public_path__ + "static/media/BD135_Transistor.1b51bd38.jpg";